import { AnnotatedLightbox } from "@/components/lightbox";
import { client } from "@/hono";
import { BlankSlate } from "@msuite/ui/blank-slate";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { moment } from "@msuite/utils/date";

/** Props Interface */
interface ProjectGalleryProps {
	projectId: string;
}

export function ProjectGallery({ projectId }: ProjectGalleryProps) {
	/** Hooks */

	/** Query */
	const { data: gallery, isLoading } = useQuery({
		queryKey: ["projects", "gallery", projectId],
		queryFn: async () => {
			const response = await client.projects[":projectId"].gallery.$get({
				param: { projectId },
			});
			const data = await responseHandler(response);
			return data.gallery;
		},
		staleTime: 1000,
	});

	/** Computed */
	const fileIds = gallery?.flatMap((dateItem) => dateItem.items.map((item) => item.id)) ?? [];

	/** Render */
	return (
		<AnnotatedLightbox.Provider
			itemHeight="125px"
			fileIds={fileIds}
		>
			<div className="w-full h-full overflow-hidden p-2 gap-2 flex flex-col">
				<div className="relative flex flex-col gap-2 pb-4 w-full h-full overflow-y-auto">
					{!gallery?.length && <BlankSlate isLoading={isLoading} />}
					{gallery?.map((dateItem) => (
						<div
							className="flex flex-col gap-2"
							key={dateItem.date}
						>
							<p className="font-semibold text-sm">{moment(dateItem.date).dateFormat()}</p>
							<AnnotatedLightbox.Container className="mb-8">
								{dateItem.items.map((item) => (
									<AnnotatedLightbox.Item
										key={item.id}
										src={item.signedUrl}
										{...item}
									/>
								))}
							</AnnotatedLightbox.Container>
						</div>
					))}
				</div>
			</div>
		</AnnotatedLightbox.Provider>
	);
}
